import { API_BASE_URL } from '../../../lib/config';
import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';
import CheckIcon from '@mui/icons-material/Check';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import RefreshIcon from '@mui/icons-material/Refresh';
import Modal from 'react-bootstrap/Modal';
import DownloadIcon from '@mui/icons-material/Download';
import Dropdown from 'react-bootstrap/Dropdown';
import RevisionQuote from '../revisequote';
import { useParams } from 'react-router-dom';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { postRequest, deleteRequest } from '../../../lib/api';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import { AuthContext } from '../../../authContext/context';
import Swal from 'sweetalert2';
import Notes from '../Notes/note';
import ViewQuoteDetailModal from '../../../components/ViewQuoteDetailModal';
import jsPDF from 'jspdf';

function MyVerticallyCenteredModal({ show, onHide, quoteData, leadData }) {
  const generatePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;

    // Header
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`Quote for Grant Application #${leadData?.lead_id || 'N/A'}`, 10, 20);

    // Subheading with legal fees total
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    const totalText = `Legal Fees from My Law Matters of £${(quoteData?.totals?.total?.gross || quoteData?.gross || 0).toFixed(2)} inc. VAT`;
    doc.text(totalText, 10, 35);

    // Thank you message
    doc.text('Thank you for choosing My Law Matters for your Grant Application needs.', 10, 50);

    // Create manual table
    let yPosition = 65;

    // Table header
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPosition, 60, 8); // Description column
    doc.rect(70, yPosition, 30, 8); // Net column
    doc.rect(100, yPosition, 30, 8); // VAT column
    doc.rect(130, yPosition, 40, 8); // Total column

    doc.text('Description', 12, yPosition + 5);
    doc.text('Net', 82, yPosition + 5);
    doc.text('VAT', 112, yPosition + 5);
    doc.text('Total', 142, yPosition + 5);

    yPosition += 8;

    // Table data rows
    doc.setFont('helvetica', 'normal');
    const legalFee = parseFloat(quoteData?.totals?.total?.net || quoteData?.net || 0);
    const vat = parseFloat(quoteData?.totals?.total?.vat || quoteData?.vat || 0);
    const legalTotal = parseFloat(quoteData?.totals?.total?.gross || quoteData?.gross || 0);

    // Legal Fee row
    doc.rect(10, yPosition, 60, 8);
    doc.rect(70, yPosition, 30, 8);
    doc.rect(100, yPosition, 30, 8);
    doc.rect(130, yPosition, 40, 8);

    doc.text('Legal Fees', 12, yPosition + 5);
    doc.text(`£${legalFee.toFixed(2)}`, 72, yPosition + 5);
    doc.text(`£${vat.toFixed(2)}`, 102, yPosition + 5);
    doc.text(`£${legalTotal.toFixed(2)}`, 132, yPosition + 5);

    yPosition += 8;

    // Total row
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPosition, 60, 8);
    doc.rect(70, yPosition, 30, 8);
    doc.rect(100, yPosition, 30, 8);
    doc.rect(130, yPosition, 40, 8);

    doc.text('TOTAL', 12, yPosition + 5);
    doc.text('', 72, yPosition + 5);
    doc.text('', 102, yPosition + 5);
    doc.text(`£${legalTotal.toFixed(2)}`, 132, yPosition + 5);

    // Additional details
    const finalY = yPosition + 20;
    doc.setFontSize(10);
    doc.text('This quote is valid for 30 days from the date of issue.', 10, finalY);
    doc.text(`Generated on: ${new Date().toLocaleDateString('en-GB')}`, 10, finalY + 10);

    // Footer
    doc.setFontSize(8);
    doc.text('My Law Matters - Professional Legal Services', 10, doc.internal.pageSize.height - 20);

    // Save the PDF
    const filename = `Grant_Application_Quote_${leadData?.lead_id || 'Quote'}.pdf`;
    doc.save(filename);

    Swal.fire('Success', 'Quote downloaded successfully!', 'success');
  };

  const handleDownload = () => {
    generatePDF();
  };

  return (
    <Modal show={show} onHide={onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6' }}>
        <Modal.Title id="contained-modal-title-vcenter">View Quote</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <Table bordered hover style={{ marginBottom: 0 }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th style={{ fontWeight: '600', width: '50%' }}>Grant Application</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>Net</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>VAT</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>Gross</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Legal Fees</td>
                <td className="text-center">£{(quoteData?.totals?.total?.net || quoteData?.net || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                <td className="text-center">£{(quoteData?.totals?.total?.vat || quoteData?.vat || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                <td className="text-center">£{(quoteData?.totals?.total?.gross || quoteData?.gross || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
              </tr>
            </tbody>
          </Table>
        </div>

        <div className="mt-3 text-center">
          <Button
            variant="primary"
            onClick={handleDownload}
            style={{ minWidth: '150px' }}
          >
            <DownloadIcon fontSize="small" style={{ marginRight: '8px' }} />
            DOWNLOAD
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}


export default function ViewLeadGrantApplication() {
  const [modalShow, setModalShow] = React.useState(false);
  const [leadData, setLeadData] = React.useState(null);
  const [contactAttempts, setContactAttempts] = React.useState(leadData?.contact_attempts || 0);
  const [partners, setPartners] = React.useState([]);
  const [quoteFeeData, setQuoteFeeData] = React.useState(null);
  const [loadingFee, setLoadingFee] = React.useState(false);
  const [quoteHistory, setQuoteHistory] = React.useState([]);
  const [showQuoteDetailModal, setShowQuoteDetailModal] = React.useState(false);
  const [selectedQuote, setSelectedQuote] = React.useState(null);
  const [showReviseModal, setShowReviseModal] = React.useState(false);
  const [revisedLegalCost, setRevisedLegalCost] = React.useState(0);
  const navigate = useNavigate();
  const authCtx = React.useContext(AuthContext);

  const{id} = useParams()

  const handleUpdateContactAttempt = async (type) => {
  let updatedCount = contactAttempts;

  if (type === 'increase') updatedCount += 1;
  else if (type === 'reset') updatedCount = 0;

  try {
    const res = await postRequest('private/change-contact-status', {
      lead_id: id,
      contact_attempts: updatedCount,
    }, authCtx.token);

    if (res.status === 200 || res.status === 'success') {
      setContactAttempts(updatedCount);
     // alert('Contact attempts updated successfully!');
    } else {
     // alert('Failed to update contact attempts.');
    }
  } catch (err) {
    console.error('Error:', err);
   // alert('Error updating contact attempts.');
  }
};

const handleDeleteLead = () => {
  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const res = await deleteRequest(`private/delete-lead/${id}`, {}, authCtx.token);
        if (res.status === 200 || res.status === 'success') {
          Swal.fire(
            'Deleted!',
            'The lead has been deleted.',
            'success'
          );
          navigate('/leads');
        } else {
          Swal.fire('Error!', res.message || 'Failed to delete lead.', 'error');
        }
      } catch (err) {
        console.error('Error deleting lead:', err);
        Swal.fire('Error!', 'An error occurred while deleting the lead.', 'error');
      }
    }
  });
};

  const slugify = (text) =>
  text
    ?.toLowerCase()
    ?.replace(/ /g, '-')      // spaces to hyphen
    ?.replace(/[^\w-]+/g, '') // remove special chars
    ?.replace(/-+/g, '-');    // collapse consecutive hyphens to single hyphen


 // const lead_id = "L-10"; // Replace with dynamic id if needed

  const fetchPartners = async () => {
    try {
      const res = await postRequest('private/partnersList', {}, authCtx.token);
      if (res?.status === 200 && res?.data) {
        setPartners(res.data);
      }
    } catch (err) {
      console.error('Error fetching partners:', err);
    }
  };

  React.useEffect(() => {
    async function fetchLead() {
      try {
        const res = await postRequest(`private/lead-overview-data/${id}`, {}, authCtx.token);
        if (res.status === 'success') {
          setLeadData(res.data);
        }
      } catch (err) {
        console.error("Error fetching lead data", err);
      }
    }

    fetchLead();
    // fetchPartners();
  }, [id, authCtx.token]);

  // Fetch latest quote from database (for displaying after revisions)
  const fetchLatestQuote = async () => {
    if (!leadData?.lead_id) return;

    try {
      setLoadingFee(true);

      // Fetch quote history to get the latest active quote
      const res = await postRequest('private/getFinalLeadCalculations', {
        lead_id: leadData.lead_id
      }, authCtx.token);

      if (res.status === 200 && res.data && res.data.length > 0) {
        // Get the most recent calculation (first in array as they're sorted by createdAt desc)
        const latestQuote = res.data[0];

        // Transform to match quoteFeeData format
        const transformedData = {
          complexity: latestQuote.fees?.legalFee?.complexity || '',
          rangeLabel: latestQuote.fees?.legalFee?.rangeLabel || '',
          net: latestQuote.totals?.total?.net || 0,
          vat: latestQuote.totals?.total?.vat || 0,
          gross: latestQuote.totals?.total?.gross || 0,
          fees: latestQuote.fees || {},
          disbursements: latestQuote.disbursements || {},
          totals: latestQuote.totals || {},
          rate_card_type: latestQuote.rate_card_type,
          branch_name: latestQuote.branch_name
        };

        console.log('✅ Latest Quote from Database:', transformedData);
        setQuoteFeeData(transformedData);
      }
    } catch (err) {
      console.error('❌ Error fetching latest quote:', err);
    } finally {
      setLoadingFee(false);
    }
  };

  // Fetch grant application fee (calculates from rate card)
  const fetchGrantApplicationFee = async () => {
    if (!leadData || !leadData.net_value || !leadData.product_id) {
      return;
    }

    try {
      setLoadingFee(true);

      // Check if LSS Grant Application
      const isLss = leadData?.product_title?.toLowerCase().includes('lss');
      const endpoint = isLss ? 'private/getLssGrantApplicationFee' : 'private/getGrantApplicationFee';

      const payload = {
        lead_id: leadData.lead_id,
        product_id: leadData.product_id,
        net_value: leadData.net_value,
        partner_id: leadData.partner_id,
        branch_id: leadData.branch_id
        // Don't send complexity - let backend auto-match based on net_value
      };

      console.log(`🎯 Fetching ${isLss ? 'LSS ' : ''}Grant Application Fee:`, payload);

      const res = await postRequest(endpoint, payload, authCtx.token);

      if (res.status === 200 && res.data) {
        console.log('✅ Grant Application Fee Data:', res.data);
        setQuoteFeeData(res.data);
      }
    } catch (err) {
      console.error('❌ Error fetching grant application fee:', err);
    } finally {
      setLoadingFee(false);
    }
  };

  // Fetch quote history from final_leads_calculations
  const fetchQuoteHistory = async () => {
    if (!leadData?.lead_id) return;

    try {
      const res = await postRequest('private/getFinalLeadCalculations', {
        lead_id: leadData.lead_id
      }, authCtx.token);

      if (res.status === 200 && res.data) {
        console.log('✅ Quote History:', res.data);
        setQuoteHistory(res.data);
      }
    } catch (err) {
      console.error('❌ Error fetching quote history:', err);
    }
  };

  // Fetch grant application fee when leadData is loaded
  // First try to get from database, if not exists then calculate from rate card
  React.useEffect(() => {
    const loadQuoteData = async () => {
      if (!leadData?.lead_id) return;

      try {
        // Try to get existing quote from database first
        const res = await postRequest('private/getFinalLeadCalculations', {
          lead_id: leadData.lead_id
        }, authCtx.token);

        if (res.status === 200 && res.data && res.data.length > 0) {
          // Quote exists in database, use it
          console.log('✅ Loading existing quote from database');
          await fetchLatestQuote();
        } else {
          // No quote in database, calculate from rate card
          console.log('💾 No existing quote, calculating from rate card');
          await fetchGrantApplicationFee();
          // Wait a moment for the calculation to be saved to database
          await new Promise(resolve => setTimeout(resolve, 500));
        }

        // Fetch quote history after quote data is loaded
        await fetchQuoteHistory();
      } catch (err) {
        console.error('❌ Error loading quote data:', err);
        // Fallback to rate card calculation
        await fetchGrantApplicationFee();
        await new Promise(resolve => setTimeout(resolve, 500));
        await fetchQuoteHistory();
      }
    };

    loadQuoteData();
  }, [leadData?.lead_id, authCtx.token]);

  const handleViewQuoteDetail = (quote) => {
    // For Quote History: transform quote to match quoteFeeData format
    const transformedQuote = {
      net: quote.totals?.total?.net || quote.net || 0,
      vat: quote.totals?.total?.vat || quote.vat || 0,
      gross: quote.totals?.total?.gross || quote.gross || 0,
      totals: quote.totals,
      fees: quote.fees,
      disbursements: quote.disbursements
    };
    setQuoteFeeData(transformedQuote);
    setModalShow(true);
  };

  // Regenerate Quote Handler
  const handleRegenerateQuote = async () => {
    try {
      const confirmResult = await Swal.fire({
        title: 'Regenerate Quote?',
        text: 'This will recalculate the quote from Manchester branch rate card.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, regenerate it!'
      });

      if (!confirmResult.isConfirmed) {
        return;
      }

      const isLss = leadData?.product_title?.toLowerCase().includes('lss');
      const endpoint = isLss
        ? `private/regenerate-lss-grant-application-quote/${id}`
        : `private/regenerate-grant-application-quote/${id}`;

      const res = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authCtx.token}`
        }
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`API call failed: ${res.status} - ${errorText}`);
      }

      const result = await res.json();

      if (result.status === 200) {
        // Refresh quote history and latest quote from database
        await fetchQuoteHistory();
        await fetchLatestQuote();

        Swal.fire('Success', 'Quote regenerated successfully!', 'success');
      } else {
        Swal.fire('Error', result?.message || 'Failed to regenerate quote', 'error');
      }
    } catch (err) {
      console.error('❌ Error regenerating quote:', err);
      Swal.fire('Error', err?.message || 'Something went wrong', 'error');
    }
  };

  // Revise Quote Handler
  const handleReviseQuote = async () => {
    try {
      if (!revisedLegalCost || revisedLegalCost <= 0) {
        Swal.fire('Error', 'Please enter a valid MLM Legal Cost', 'error');
        return;
      }

      const isLss = leadData?.product_title?.toLowerCase().includes('lss');
      const endpoint = isLss
        ? `private/update-lss-grant-application-quote/${id}`
        : `private/update-grant-application-quote/${id}`;

      const res = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authCtx.token}`
        },
        body: JSON.stringify({
          mlmLegalCost: parseFloat(revisedLegalCost)
        })
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`API call failed: ${res.status} - ${errorText}`);
      }

      const result = await res.json();

      if (result.status === 200) {
        // Refresh quote history and latest quote from database
        await fetchQuoteHistory();
        await fetchLatestQuote();

        Swal.fire('Success', 'Quote revised successfully!', 'success');
        setShowReviseModal(false);
        setRevisedLegalCost(0);
      } else {
        Swal.fire('Error', result?.message || 'Failed to revise quote', 'error');
      }
    } catch (err) {
      console.error('❌ Error revising quote:', err);
      Swal.fire('Error', err?.message || 'Something went wrong', 'error');
    }
  };

  return (
    <>
      <BreadcrumbsWrapper
                   items={[
                   { label: 'Dashboard', path: '/dashboard' },
                   { label: 'Leads', path: '/leads' },
                   { label: 'View Leads', path: '' },
                 
                      ]}
                        />
                       <br></br>
    
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>
          {leadData ? `${leadData.product_title} #${leadData.lead_id}` : 'Loading...'}
        </h1>
      </div>

      <div className='page-top-formview mb-3'>
        <div className='customer-tab-view leads-tab-view'>
          <Tabs defaultActiveKey="overview" id="uncontrolled-tab-example">
            {/* OVERVIEW */}
            <Tab eventKey="overview" title="Overview">
              <div className='mt-3'>
                {/* Quote Summary Box */}
                <div className="card shadow-sm mb-4" style={{ borderRadius: '10px', overflow: 'hidden' }}>
                  <div className="card-header" style={{
                    backgroundColor: '#f8f9fa',
                    borderBottom: '2px solid #e9ecef',
                    padding: '1rem 1.25rem'
                  }}>
                    <h5 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
                      Quote Summary
                    </h5>
                  </div>
                  <div className="card-body" style={{ padding: '1.5rem' }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-baseline gap-3">
                        <span className="text-muted small">Total Cost</span>
                        {loadingFee ? (
                          <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                            Loading...
                          </span>
                        ) : quoteFeeData ? (
                          <>
                            <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                              £{(quoteFeeData.net || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Net + £{(quoteFeeData.vat || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} VAT = £{(quoteFeeData.gross || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Gross
                            </span>
                            {quoteFeeData && (quoteFeeData.partner_name || quoteFeeData.branch_name) && (
                              <span className="badge bg-info text-white ms-2">
                                {quoteFeeData.rate_card_type === 'PARTNER' && quoteFeeData.partner_name ? (
                                  <>Partner: {quoteFeeData.partner_name}</>
                                ) : quoteFeeData.rate_card_type === 'BRANCH' && quoteFeeData.branch_name ? (
                                  <>Branch: {quoteFeeData.branch_name}</>
                                ) : null}
                              </span>
                            )}
                          </>
                        ) : (
                          <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                            £{(leadData?.net_value || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Net + £{(leadData?.vat_amount || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} VAT = £{(leadData?.gross_value || leadData?.total_quote || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Gross
                          </span>
                        )}
                      </div>
                    </div>
                    {leadData?.created_at && (
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <span className="text-muted small">
                          {new Date(leadData.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })} {new Date(leadData.created_at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                        </span>
                        <div>
                          {leadData?.group_code_code && (
                            <span className="badge rounded-pill bg-secondary me-2">{leadData.group_code_code}</span>
                          )}
                          {leadData?.created_by && (
                            <span className="badge rounded-pill bg-info">{leadData.created_by}</span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Action Buttons */}
                  <div className="card-footer bg-light" style={{ borderTop: '1px solid #e9ecef', padding: '1rem 1.25rem' }}>
                    <div className="d-flex gap-2 flex-wrap align-items-center">
                      {leadData?.status !== 'Instructed' && (
                        <>
                          <Button
                            variant="contained"
                            className='text-capitalize'
                            onClick={() => {
                              // Set initial value from current quote
                              if (quoteFeeData?.net) {
                                setRevisedLegalCost(quoteFeeData.net);
                              }
                              setShowReviseModal(true);
                            }}
                            disabled={loadingFee}
                            style={{
                              backgroundColor: '#dc3545',
                              borderColor: '#dc3545',
                              fontSize: '0.875rem',
                              padding: '8px 16px'
                            }}
                          >
                            <EditOutlinedIcon fontSize="small" style={{ marginRight: '6px' }} />
                            {loadingFee ? 'Loading...' : 'Revise Quote'}
                          </Button>
                          <Button
                            variant="outlined"
                            className='text-capitalize'
                            onClick={handleRegenerateQuote}
                            style={{
                              color: '#6c757d',
                              borderColor: '#6c757d',
                              fontSize: '0.875rem',
                              padding: '8px 16px'
                            }}
                          >
                            <RefreshIcon fontSize="small" style={{ marginRight: '6px' }} />
                            Regenerate Quote
                          </Button>
                        </>
                      )}
                      <Button
                        variant="outlined"
                        className='text-capitalize'
                        onClick={() => {
                          if (quoteFeeData) {
                            setModalShow(true);
                          }
                        }}
                        style={{
                          color: '#007bff',
                          borderColor: '#007bff',
                          fontSize: '0.875rem',
                          padding: '8px 16px'
                        }}
                      >
                        <i className="fas fa-eye me-1"></i>
                        View Quote Detail
                      </Button>
                      <Button
                        variant="text"
                        className='text-capitalize'
                        onClick={() => console.log('View Quote History')}
                        style={{
                          color: '#6c757d',
                          fontSize: '0.875rem',
                          padding: '8px 16px'
                        }}
                      >
                        <i className="fas fa-history me-1"></i>
                        View History
                      </Button>
                    </div>
                  </div>
                </div>

                <ul className="list-group mb-3">
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Customers</div>
                      <div className="col-8">{leadData?.customers || '-'}</div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Net State Value</div>
                      <div className="col-8">£{leadData?.net_value?.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Group Code</div>
                      <div className="col-8">{leadData?.group_code_code}</div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Status</div>
                      <div className="col-8">{leadData?.status}</div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Complexity</div>
                      <div className="col-8">None</div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-4 fw-bold">Lender Panel</div>
                      <div className="col-8">
                        {(() => {
                          const lenderPanel = leadData?.lender_panel_id;

                          // If lender panel is populated object
                          if (lenderPanel && typeof lenderPanel === 'object' && lenderPanel.name) {
                            return (
                              <div>
                                <div>
                                  <span className="badge bg-info">
                                    {lenderPanel.name}
                                  </span>
                                </div>
                                {lenderPanel?.lender_numbers && lenderPanel.lender_numbers.length > 0 && (
                                  <div style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                        <span style={{ fontWeight: '500' }}>Lender Panel Number: </span>
                                    {lenderPanel.lender_numbers.join(', ')}
                                  </div>
                                )}
                              </div>
                            );
                          }

                          // If no lender panel selected
                          return <span className="text-muted">Not specified</span>;
                        })()}
                      </div>
                    </div>
                  </li>
                  {leadData?.partner_id && (
                    <li className="list-group-item">
                      <div className="row">
                        <div className="col-4 fw-bold">Partner</div>
                        <div className="col-8">
                          {(() => {
                            const partnerId = typeof leadData.partner_id === 'object' ? leadData.partner_id._id : leadData.partner_id;
                            const partner = partners.find(p => p._id === partnerId);
                            if (partner) {
                              return partner.name;
                            }
                            return <span className="text-muted">Not specified</span>;
                          })()}
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
              <Row className='m-0'>
                <Stack spacing={2} direction="row" style={{ justifyContent: 'space-between', padding: 0 }}>
                  <Button variant="outlined" className='red-outline-btn text-capitalize'>
                  <NavLink
                  to={`/leads/${slugify(leadData?.product_title)}/edit/${leadData?.product_id}/${leadData?.lead_id}`}
                  className="red-link-text"
                >
                  <EditOutlinedIcon /> &nbsp; Edit
                </NavLink>

                  </Button>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span className="me-3">
                      Created: {leadData ? new Date(leadData.created_at).toLocaleDateString() + `- ${leadData.created_by}` : 'Loading...'}
                    </span>
                    <Dropdown className='mb-0 ps-0 '>
                      <Dropdown.Toggle className='dropdown-border-btn red-outline-btn text-capitalize'>
                        More Action
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>
                          <Link to="/leads/changestatus" state={{ id: id , title:slugify(leadData?.product_title) }}>
                                  Change Status
                                </Link>
                        </Dropdown.Item>
                        <Dropdown.Item><Link to="/leads/changegroupcode" state={{ id: id , title:slugify(leadData?.product_title) }}>Change Group Code</Link></Dropdown.Item>
                        <Dropdown.Item onClick={handleDeleteLead}>Delete Lead</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Stack>
              </Row>
            </Tab>

            {/* QUOTES */}
            <Tab eventKey="quotes" title="Quotes">
              <div className='mt-3'>
                {quoteHistory.length > 0 ? (
                  <div className="quote-history-section">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                        <i className="fas fa-history me-2" style={{ color: '#3498db' }}></i>
                        Quote History
                      </h5>
                      <span className="badge bg-primary" style={{ fontSize: '0.9rem', padding: '6px 12px' }}>
                        {quoteHistory.length} {quoteHistory.length === 1 ? 'Version' : 'Versions'}
                      </span>
                    </div>

                    <div className="timeline" style={{ position: 'relative', paddingLeft: '30px' }}>
                      {/* Timeline line */}
                      <div style={{
                        position: 'absolute',
                        left: '8px',
                        top: '20px',
                        bottom: '20px',
                        width: '2px',
                        backgroundColor: '#e0e0e0'
                      }}></div>

                      {quoteHistory.map((quote, index) => {
                        const totalGross = quote.totals?.total?.gross || 0;
                        const totalVat = quote.totals?.total?.vat || 0;
                        const legalCostGross = quote.totals?.legalCost?.gross || 0;
                        const isActive = index === 0; // Latest quote is active
                        const displayDate = quote.createdAt;

                        return (
                          <div key={quote._id || index} style={{ position: 'relative', marginBottom: '24px' }}>
                            {/* Timeline dot */}
                            <div style={{
                              position: 'absolute',
                              left: '-26px',
                              top: '16px',
                              width: '16px',
                              height: '16px',
                              borderRadius: '50%',
                              backgroundColor: isActive ? '#27ae60' : '#95a5a6',
                              border: '3px solid white',
                              boxShadow: isActive ? '0 0 0 2px #27ae60' : '0 0 0 2px #95a5a6',
                              zIndex: 1
                            }}></div>

                            {/* Card */}
                            <div className="card" style={{
                              border: `2px solid ${isActive ? '#27ae60' : '#e9ecef'}`,
                              borderRadius: '12px',
                              boxShadow: isActive ? '0 4px 12px rgba(39, 174, 96, 0.15)' : '0 2px 8px rgba(0,0,0,0.08)',
                              transition: 'all 0.3s ease',
                              backgroundColor: isActive ? '#f8fff9' : 'white'
                            }}>
                              <div className="card-body" style={{ padding: '20px' }}>
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                  {/* Left: Version & Amount */}
                                  <div className="flex-grow-1">
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                      <i className={`fas ${isActive ? 'fa-check-circle' : 'fa-file-invoice'}`} style={{ color: isActive ? '#27ae60' : '#95a5a6', fontSize: '18px' }}></i>
                                      <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                                        {isActive ? 'Current' : `Version ${quoteHistory.length - index}`}
                                      </h5>
                                      {isActive && (
                                        <span className="badge" style={{
                                          backgroundColor: '#27ae60',
                                          color: 'white',
                                          padding: '4px 10px',
                                          borderRadius: '6px',
                                          fontSize: '0.75rem',
                                          fontWeight: 600
                                        }}>
                                          CURRENT
                                        </span>
                                      )}
                                    </div>

                                    {/* Date & Time */}
                                    <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                      <i className="far fa-clock me-1"></i>
                                      {new Date(displayDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric'
                                      })} at {new Date(displayDate).toLocaleTimeString('en-GB', {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </p>

                                    {/* Source Badge */}
                                    <span className="badge" style={{
                                      backgroundColor: '#95a5a6',
                                      color: 'white',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      fontSize: '0.7rem'
                                    }}>
                                      AUTO CALCULATED
                                    </span>
                                  </div>

                                  {/* Right: Partner/Branch & Action */}
                                  <div className="d-flex flex-column align-items-end gap-2">
                                    {(quote.partner_name || quote.branch_name) && (
                                      <span className="badge" style={{
                                        backgroundColor: '#e8f4f8',
                                        color: '#3498db',
                                        padding: '6px 12px',
                                        borderRadius: '6px',
                                        fontSize: '0.75rem',
                                        fontWeight: 600
                                      }}>
                                        <i className="fas fa-building me-1"></i>
                                        {quote.rate_card_type === 'PARTNER' && quote.partner_name ? (
                                          <>Partner: {quote.partner_name}</>
                                        ) : quote.rate_card_type === 'BRANCH' && quote.branch_name ? (
                                          <>Branch: {quote.branch_name}</>
                                        ) : quote.branch_name || quote.partner_name}
                                      </span>
                                    )}
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      style={{
                                        borderRadius: '8px',
                                        padding: '6px 16px',
                                        fontSize: '0.8rem',
                                        fontWeight: 500,
                                        borderWidth: '2px'
                                      }}
                                      onClick={() => handleViewQuoteDetail(quote)}
                                    >
                                      <VisibilityIcon fontSize="small" style={{ fontSize: '14px', marginRight: '4px' }} />
                                      VIEW DETAILS
                                    </Button>
                                  </div>
                                </div>

                                {/* Pricing Breakdown */}
                                <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
                                  <div className="row g-3">
                                    {/* Total Amount - Highlighted */}
                                    <div className="col-md-4">
                                      <div style={{
                                        backgroundColor: isActive ? '#e8f5e9' : '#f8f9fa',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        textAlign: 'center'
                                      }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' }}>
                                          Total Amount
                                        </p>
                                        <h4 className="mb-0" style={{ color: isActive ? '#27ae60' : '#2c3e50', fontWeight: 700 }}>
                                          £{Number(totalGross).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </h4>
                                      </div>
                                    </div>

                                    {/* Legal Costs */}
                                    <div className="col-md-4">
                                      <div style={{ padding: '12px' }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                          <i className="fas fa-balance-scale me-1"></i>
                                          Legal Costs
                                        </p>
                                        <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                          £{Number(legalCostGross).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </h6>
                                      </div>
                                    </div>

                                    {/* VAT */}
                                    <div className="col-md-4">
                                      <div style={{ padding: '12px' }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                          <i className="fas fa-receipt me-1"></i>
                                          VAT Included
                                        </p>
                                        <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                          £{Number(totalVat).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <p className="text-muted">No quotes available.</p>
                )}
              </div>
            </Tab>

            {/* NOTES */}
            <Tab eventKey="notes" title="Notes">
              <Notes lead_id={id} product_id= {leadData?.product_id}/>
            </Tab>

            {/* COMMUNICATION */}
            {/* <Tab eventKey="communication" title="Communication">
              <div className='communication-table'>
                <Table striped responsive bordered>
                  <thead>
                    <tr>
                      <th>Sent</th>
                      <th>Customer</th>
                      <th>Content</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><MailOutlineIcon /> &nbsp; 04/07/2025 01:00</td>
                      <td>Jack Doe</td>
                      <td>Local Authority, Water & Drainage, Environmental Search <ExitToAppIcon /></td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Tab> */}
            <Tab eventKey="communication" title="Communication">
  <div className='communication-table'>
    <Dropdown>
      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
        Contact Attempt ({contactAttempts})
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => handleUpdateContactAttempt('increase')}>
          <MailOutlineIcon fontSize="small" /> &nbsp; Increase Contact Attempt Count
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleUpdateContactAttempt('reset')}>
          <CallOutlinedIcon fontSize="small" /> &nbsp; Reset
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  </div>
</Tab>


            {/* APPOINTMENT / TASKS */}
            <Tab eventKey="appointment" title="Tasks">
              <div className='mt-4'>
                <div className="text-center py-5">
                  <i className="fas fa-tasks fa-3x text-muted mb-3"></i>
                  <h5 className="text-muted">No Tasks Available</h5>
                  <p className="text-muted">No tasks have been created for this lead yet.</p>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        quoteData={quoteFeeData}
        leadData={leadData}
      />

      <ViewQuoteDetailModal
        show={showQuoteDetailModal}
        onHide={() => setShowQuoteDetailModal(false)}
        leadData={{
          ...leadData,
          service_type: 'Grant_Application'
        }}
        legalFeeData={{
          fees: selectedQuote?.fees || {},
          disbursements: selectedQuote?.disbursements || {},
          totals: selectedQuote?.totals || {}
        }}
        calculationTotals={selectedQuote?.totals || null}
      />

      {/* Revise Quote Modal */}
      <Modal show={showReviseModal} onHide={() => setShowReviseModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Revise Quote - Grant Application</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered>
            <thead>
              <tr>
                <th>Description</th>
                <th style={{ width: '150px' }}>Net (£)</th>
                <th style={{ width: '150px' }}>VAT (£)</th>
                <th style={{ width: '150px' }}>Gross (£)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>MLM Legal Cost</strong></td>
                <td>
                  <Form.Control
                    type="number"
                    value={revisedLegalCost}
                    onChange={(e) => setRevisedLegalCost(e.target.value)}
                    step="0.01"
                    min="0"
                  />
                </td>
                <td className="align-middle">
                  £{(Number(revisedLegalCost) * 0.20).toFixed(2)}
                </td>
                <td className="align-middle">
                  £{(Number(revisedLegalCost) * 1.20).toFixed(2)}
                </td>
              </tr>
              {/* TOTAL LEGAL COST */}
              <tr style={{ backgroundColor: '#fff3cd', fontWeight: '600', borderTop: '2px solid #dee2e6' }}>
                <td>TOTAL LEGAL COST</td>
                <td>£{Number(revisedLegalCost).toFixed(2)}</td>
                <td>£{(Number(revisedLegalCost) * 0.20).toFixed(2)}</td>
                <td>£{(Number(revisedLegalCost) * 1.20).toFixed(2)}</td>
              </tr>

              {/* TOTAL DISBURSEMENT COST */}
              <tr style={{ backgroundColor: '#d1ecf1', fontWeight: '600' }}>
                <td>TOTAL DISBURSEMENT COST</td>
                <td>£0.00</td>
                <td>£0.00</td>
                <td>£0.00</td>
              </tr>

              {/* Total (Legal cost + disbursement) */}
              <tr style={{ backgroundColor: '#d4edda', fontWeight: '700', borderTop: '2px solid #28a745' }}>
                <td>Total (Legal cost + disbursement)</td>
                <td>£{Number(revisedLegalCost).toFixed(2)}</td>
                <td>£{(Number(revisedLegalCost) * 0.20).toFixed(2)}</td>
                <td>£{(Number(revisedLegalCost) * 1.20).toFixed(2)}</td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={() => setShowReviseModal(false)}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleReviseQuote} style={{ paddingLeft: '25px', paddingRight: '25px', fontWeight: '500' }}>
            Revise Quote
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
